import crud_actions from './crud_actions'

export const loadFlatActivities = crud_actions.read(
  'activities/flat',
  'loadFlatActivities'
)
export const loadAggregatedActivities = crud_actions.read(
  'activities/aggregated',
  'loadAggregatedActivities'
)
export const loadGroupActivities = crud_actions.read(
  'activities/group',
  'loadGroupActivities'
)

export const loadNotifications = crud_actions.read('notifications')
